import React, { FC, useState } from 'react';
import { Button, ButtonProps } from '@components/UIKit/Button/Button';
import { useTranslation } from '@hooks/useTranslation';
import dynamic from 'next/dynamic';
import { toy } from '@prisma/client';
const Modal = dynamic(import('@components/Modals/Modal').then(module => module.Modal), {
  ssr: false
});
const GenerateCodes = dynamic(import('@components/Modals/Variants/GenerateCodes/GenerateCodes').then(module => module.GenerateCodes), {
  ssr: false
});
interface Props extends Omit<ButtonProps, 'children'> {
  toyId: toy['id'];
  slug: toy['slug'];
  name: toy['name'];
}
export const GenerateQrButton: FC<Props> = ({
  toyId,
  slug,
  name,
  ...props
}) => {
  const {
    translate: tr
  } = useTranslation();
  const [isOpenModal, setIsOpenModal] = useState(false);
  const generateQrHandler = async () => {
    setIsOpenModal(true);
  };
  const closeHandler = () => {
    setIsOpenModal(false);
  };
  return <>
            <Button {...props} onClick={generateQrHandler} data-sentry-element="Button" data-sentry-source-file="GenerateQrButton.tsx">
                {tr({
        id: 'btn.generate.qr'
      })}
            </Button>
            <Modal isOpen={isOpenModal} onClose={closeHandler} data-sentry-element="Modal" data-sentry-source-file="GenerateQrButton.tsx">
                <GenerateCodes closeHandler={closeHandler} toyId={toyId} slug={slug} name={name} data-sentry-element="GenerateCodes" data-sentry-source-file="GenerateQrButton.tsx" />
            </Modal>
        </>;
};